<script setup lang="ts">
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import HotelView from './HotelView.vue';
import type HotelPackage from '@itinerary/hotel/HotelPackage';

const { item } = defineProps<{
    item: HotelPackage;
}>();

const { isMobile } = useSize();

const expanded = ref(false);

onMounted(() => {
    expanded.value = !isMobile.value;
});
</script>

<template>
    <div class="reserve-sidebar-container">
        <div class="header">
            <img v-if="item.photo?.large" :src="item.photo.large" alt="hotel" />
            <h4>{{ item.title }}</h4>
            <mr-button
                :icon-button="{
                    icon: expanded ? faChevronUp : faChevronDown,
                    color: 'black',
                }"
                size="small"
                variant="transparent"
                @click="expanded = !expanded"
            />
        </div>

        <div class="content-container" :class="{ expanded }">
            <HotelView :item />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.reserve-sidebar-container {
    background: white;
    border-radius: 10px;
    width: 100%;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        @include f-gap(8px);
        img {
            width: 60px;
            height: 60px;
            object-fit: cover;
            background-color: usePalette($p-blue, $p-100);
            border-radius: 8px;
        }
        h4 {
            @include tg-display4($w7);
            flex-grow: 1;
        }
    }

    .content-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        transition: max-height 400ms ease;
        max-height: 0;
        overflow: hidden;
        padding: 0 8px;
        margin-bottom: 8px;
        &.expanded {
            max-height: 100px;
        }
    }
}
</style>
